import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { calculatorService } from '../../services/calculatorService';

export const useGetGrowthCalculatorResult = (params, enabled) => {
  return useQuery({
    staleTime: Infinity,
    enabled,
    placeholderData: keepPreviousData,
    queryKey: [QUERY_KEYS.calculator.growth_result, params],
    queryFn: () =>
      calculatorService.growth(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
